import React from "react";
import { Button, Column, Columns, Modal, Section, Title } from "@allxsmith/bestax-bulma";


export default function InspectionCountModal({open, setOpen, count, onCancel}){

    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            active={open}
            onClose={() => {
                setOpen(false);
            }}
            closeOnBlur
        >
            <Modal.Content>
                <Section style={{background: "white"}}>
                    <Title>THERE ARE {count} INSPECTIONS BOOKED ON THAT DATE</Title>
                    <Columns isMultiline>
                        <Column>
                            <Button
                                color={"success"}
                                onClick={onCancel}
                                isFullWidth
                            >
                                Close
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );



}